import React from 'react';
import { ClockIcon, MailIcon } from 'lucide-react';
import { ArrowButton } from './ui/ArrowButton';
import { Reveal } from './ui/Reveal';
import { SplitText } from './ui/SplitText';
import { contactInfo } from '../data/navigation';
const marqueeWords = ['Achats', 'Supply chain', 'Négociation', 'Fournisseurs', 'Stocks', 'Performance'];
export function CtaBanner() {
  return <section className="bg-paper px-3 pb-3 pt-10 sm:px-5 sm:pb-5" data-id="element-25" data-mp="1wadvhy63uwov">
      <div className="relative isolate overflow-hidden rounded-[28px] bg-ink px-6 py-16 text-white sm:px-12 lg:px-16 lg:py-24" data-id="element-26" data-mp="1w8kyzbp7hsul">
        <div className="pointer-events-none absolute inset-x-0 bottom-4 -z-10 flex overflow-hidden" aria-hidden="true" data-id="element-27" data-mp="1mc7udis4hul2">
          {[0, 1].map(k => <div key={k} className="flex shrink-0 animate-marquee-slow items-center" data-id="element-28" data-mp="1hcv7iy194nih">
              {marqueeWords.map(w => <span key={w} className="whitespace-nowrap pr-12 text-[clamp(4rem,10vw,9rem)] font-semibold leading-none tracking-tight text-white/[0.04]" data-id="element-29" data-mp="auyef687dkoi">
                  {w}
                </span>)}
            </div>)}
        </div>

        <div className="grid gap-12 lg:grid-cols-12 lg:items-end" data-id="element-30" data-mp="1g6ktr0vbih2l">
          <div className="lg:col-span-8" data-id="element-31" data-mp="11b4t2d08fmx8">
            <h2 className="max-w-3xl text-[clamp(2rem,4.4vw,3.75rem)] font-medium leading-[1.06] tracking-[-0.03em]" data-id="element-32" data-mp="11ad7zw49h7l7">
              <SplitText text="Et si vos achats devenaient votre meilleur levier de marge ?" data-id="element-33" data-mp="16bj29ydkl2wu" />
            </h2>
            <Reveal delay={0.2} data-id="element-34" data-mp="x91e3eecu077">
              <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/70" data-id="element-35" data-mp="x99ql56kf3hv">
                Un premier échange de 30 minutes, gratuit et sans engagement, pour identifier vos gisements d’économies
                et vos priorités.
              </p>
              <div className="mt-10 flex flex-wrap gap-3" data-id="element-36" data-mp="ngvno93r3qu4">
                <ArrowButton to="/contact" variant="light" data-id="element-37" data-mp="9kqkmwazn2sy">
                  Réserver un diagnostic
                </ArrowButton>
                <ArrowButton to="/services" variant="outline" data-id="element-38" data-mp="dn5159r6pqh2">
                  Voir les services
                </ArrowButton>
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.3} className="lg:col-span-4" data-id="element-39" data-mp="2bfei71wuwsvn">
            <div className="space-y-5 border-l border-white/15 pl-6" data-id="element-40" data-mp="26hczii3cevkp">
              <div className="flex items-start gap-3" data-id="element-41" data-mp="21itf4m4edrug">
                <ClockIcon className="mt-0.5 h-5 w-5 shrink-0 text-brass" aria-hidden="true" data-id="element-42" data-mp="21k4fsd2jqjhc" />
                <div data-id="element-43" data-mp="2z58xrr8k8vjl">
                  <p className="font-medium" data-id="element-44" data-mp="2z5sdr2enh9uz">Réponse sous 24 h ouvrées</p>
                  <p className="text-sm text-white/60" data-id="element-45" data-mp="2u8sa0y59wj71">Du lundi au vendredi</p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-46" data-mp="2p6krfppxu4vq">
                <MailIcon className="mt-0.5 h-5 w-5 shrink-0 text-brass" aria-hidden="true" data-id="element-47" data-mp="2l7c16uu3wp4x" />
                <div data-id="element-48" data-mp="1dtqpaqzm0sov">
                  <a href={`mailto:${contactInfo.email}`} className="break-all font-medium hover:underline" data-id="element-49" data-mp="1dua9yfgn9v6l">
                    {contactInfo.email}
                  </a>
                  <p className="text-sm text-white/60" data-id="element-50" data-mp="3lfipqibj24ii">{contactInfo.phone}</p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}